import React, {
    Component,
    Fragment,
} from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaCheck from 'react-icons/lib/fa/check';
import FaPlus from 'react-icons/lib/fa/plus';

import { Collapse } from 'wanderu-animations';
import A from 'wanderu-component-react-router-link';
import { removeLanguagePath } from 'wanderu-utils';

import styles from './VerticalMenu.scss';

class VerticalMenu extends Component {
    static propTypes = {
        selectedItemIcon: PropTypes.oneOfType([
            PropTypes.string, PropTypes.element,
        ]),
        selectedItemText: PropTypes.string,
        onToggleMenu: PropTypes.func,
    };

    static defaultProps = {
        onToggleMenu() { },
    };

    constructor(props) {
        super(props);

        this.state = {
            isMenuOpen: false,
        };
    }

    _toggleMenu = () => {
        this.props.onToggleMenu(this.state.isMenuOpen);
        this.setState((oldState) => ({
            isMenuOpen: !oldState.isMenuOpen,
        }));
    };

    render() {
        const {
            children,
            selectedItemIcon,
            selectedItemText,
        } = this.props;

        const {
            isMenuOpen,
        } = this.state;

        return (
            <Fragment>
                <div
                    aria-label={selectedItemText}
                    aria-pressed={isMenuOpen}
                    className={styles.menuItem}
                    onClick={this._toggleMenu}
                    role="button"
                >
                    <span className={styles.iconAndNameContainer}>
                        <span
                            className={styles.icon}
                        >
                            {selectedItemIcon}
                        </span>
                        {selectedItemText}
                    </span>
                    <FaPlus
                        className={
                            classNames(
                                styles.listToggle,
                                { [styles.listToggleActive]: isMenuOpen },
                            )
                        }
                    />
                </div>
                <Collapse isOpen={isMenuOpen}>
                    <ul className={styles.listContainer}>
                        {children}
                    </ul>
                </Collapse>
            </Fragment>
        );
    }
}

function VerticalMenuItem(props) {
    const {
        path,
        locale,
        isActive,
        children,
        icon,
        onClick,
    } = props;

    let componentProps = {
        href: path === '/'
            ? '/'
            : removeLanguagePath(path),
        locale,
        queries: {
            cur: undefined,
        },
        underline: 'none',
    };

    let Component = A;
    if (!path) {
        Component = 'span';
        componentProps = {
            role: 'button',
        };
    }

    return (
        <Component
            className={styles.menuItem}
            onClick={onClick}
            {...componentProps}
        >
            <span className={styles.iconAndNameContainer}>
                <span
                    className={styles.icon}
                >
                    {icon}
                </span>
                {children}
            </span>
            {isActive && <FaCheck className={styles.currentListItem} />}
        </Component>
    );
}

export {
    VerticalMenu,
    VerticalMenuItem,
};

export default {
    VerticalMenu,
    VerticalMenuItem,
};
